module.exports = __webpack_public_path__ + "img/SER-A-2-V.6522b8b5.png";